import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';
import { OPEN_WIDTH } from '../BaseNavbar.styles';

export const Header = styled.div<{
  open?: boolean;
  $isActive?: boolean;
}>`
  padding: 12px 16px;
  width: ${OPEN_WIDTH};
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: ${(props) =>
    props.$isActive
      ? props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N0
        : props.theme.atlas.semantic.color.action.secondaryInverse.onSelected
      : props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N0
        : props.theme.atlas.semantic.color.action.secondaryInverse
            .onSecondaryInverse};
  height: 100%;
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-family: ${theme.typography.fontFamily}; font-size: 14px; font-weight: 400;`
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  line-height: 1.5;
  cursor: pointer;
  background-color: ${(props) =>
    props.$isActive
      ? props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N900
        : props.theme.atlas.semantic.color.action.secondaryInverse.selected
      : props.open
        ? props.theme.isVaultVariant
          ? '#1F4751'
          : props.theme.atlas.semantic.color.action.secondaryInverse.hover
        : ''};
  &:hover {
    color: ${(props) =>
      props.theme.isVaultVariant
        ? 'white'
        : props.theme.atlas.semantic.color.action.secondaryInverse
            .onSecondaryInverse};
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N900
        : props.theme.atlas.semantic.color.action.secondaryInverse.hover};
  }
`;

export const StyledDropDownIcon = styled.i<{
  dropDownOpen?: boolean;
}>`
  color: ${(props) => props.color};
  position: relative;
  width: 10px;
  height: 10px;
  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? 'white'
        : props.theme.atlas.semantic.color.action.secondaryInverse
            .onSecondaryInverse};
    transition: transform 0.25s ease-out;
  }
  &:before {
    top: 0;
    left: 50%;
    width: 1.5px;
    height: 100%;
    margin-left: -0.75px;
  }

  &:after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 1.5px;
    margin-top: -0.75px;
  }
  ${(props) =>
    props.dropDownOpen
      ? `
  cursor: pointer;
  &:before {
    transform: rotate(90deg);
  }
  &:after {
    transform: rotate(180deg);
  }`
      : ''}
`;

export const IconTextContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;
export const IconContainer = styled.div`
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
`;
export const StyledText = styled.p<{ navOpen?: boolean }>`
  display: flex;
  justify-content: start;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${(props) => (props.navOpen ? '1' : '0')};
  width: ${(props) => (props.navOpen ? '100%' : '0%')};
  transition: all 0.36s;
  margin: 4px;
`;

export const StyledList = styled.ul`
  list-style-type: none;
  width: 100%;
  margin: 0px;
  padding: 0px 0px;
  a {
    padding-left: 45px;
  }
`;
